<script setup>
import {
  reactive, ref, getCurrentInstance, onMounted, nextTick,
} from 'vue';
import dayjs from 'dayjs';
import ChangeCat from '@/components/common/changeCat.vue';
import SearchSelectTag from '@/components/common/searchSelectTag/index.vue';
import { downloadFile } from '@/utils/download.js';
// import SearchSelectSupplier from '@/components/common/searchSelectSupplier/index.vue';
import {inNum, times, sleep} from '@/com.js';

import AddGoods from './components/AddGoods.vue';
import setGoodsOnOff from "@/views/nb/supplyChain/goods/components/setGoodsOnOff.vue";
import SyncToTTC from "@/views/nb/supplyChain/goods/components/SyncToTTC.vue";

const app = getCurrentInstance().proxy;
const userInfo = JSON.parse(localStorage.getItem('userInfo'));

const search = {
  backendCategoryId: undefined,
  // lowEstimatedProfit: undefined,
  // highEstimatedProfit: undefined,
  // lowSupplyPrice: undefined,
  // highSupplyPrice: undefined,
  // lowSellPrice: undefined,
  // highSellPrice: undefined,
  // relationGoodsTagIds: [],
  // status: undefined,
  relationSupplierName: '',
  // relationGoodsIds: undefined,
  goodsId: undefined,
  goodsName: undefined,
  currentPage: 1,
  nowPageSize: 10,
  count: 0,
  isRelation: undefined,
  scState: undefined
};
const params = reactive({ ...search });

const isReset = ref(true);
const searchSelectTagRef = ref(null);
const loading = ref(false);
const tableData = ref([]);
const pageTab = ref('yes');
const AddGoodsRef = ref(null);

// 同步商品相关
const showSyncDialog = ref(false);
const syncLoading = ref(false);
const syncGoodsId = ref('');
const syncRelationSupplierId = ref('');
const syncQudaoType = ref([1]);
const syncYxIsOnSale = ref(1);
const setGoodsOnOffRes = ref(null);

const syncToTTCRef = ref(null);
const syncTTCIsOnSale = ref(1);

function handleChange(value) {
  if (value && value.length > 0) {
    params.backendCategoryId = value[value.length - 1];
  } else {
    params.backendCategoryId = '';
  }
}
async function operation(type, row) {
  if (type === 'reset') {
    isReset.value = false;
    for (const key in search) {
      params[key] = search[key];
    }
    getList();
    nextTick(() => {
      isReset.value = true;
    });
  } else if (type === 'delete') {
    let message = '是否确认解除关联?';
    const res = await app.$axios.post(app.$api.supplychain.unRelationTip, {
      id: row.id,
    });
    if (res.code === 0 && res.data && res.data.length) {
      message = `是否确认解除关联，解除后，如已同步ERP并请手动将ERP中货品（货品编码同商品ID：${res.data}）的默认供应商及默认存放仓库改成优选，如不出售该商品，请手动将商品从优选、选品中心、ERP、京东、中国土特产等平台下架/删除。`;
    }
    app.$confirm(message, '提示', {
      confirmButtonText: '确定解除',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      deleteSumit(row);
    }).catch(() => {

    });
  }else if(type === 'deleteProduct'){
    app.$confirm('是否确定删除该商品？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      deleteProduct(row);
    }).catch(() => {

    });
  } else if (type === 'add') {
    const path = '/nb/goods/detail';
    const route = app.$router.resolve({
      path,
      query: {
        type: 'edit',
        goodsType: 1,
        backendCategoryId: row.backendCategoryId,
        goodsId: row.relationGoodsId,
        storeId: userInfo.defaultStoreId,
        suppliersId: userInfo.suppliersId,
        suppliedGoodsType: 'add',
        suppliersName: row.relationSupplierName,
        goodsBuyType: row.goodsType,
      },
    });
    window.open(window.location.origin + route.href);
  } else if (type === 'export') {
    // 导出
    await app.$confirm('是否确认导出？');
    const res = await app.$axios.get(app.$api.deliver_center.download_template, { params: getParams(1, 'get') }, { responseType: 'blob' });
    const time = dayjs(new Date()).format('YYYY-MM-DD_hh.mm.ss');
    downloadFile(res, `优选供货商品导出_${time}.xls`);
  } else if (type === 'setGoodsOnOff') {
    //设置商品上下架
    console.log('onoff', row)
    setGoodsOnOffRes.value.show(row);
  } else if (type === 'syncToTTC') {
    console.log('syncToTTC 铺货到中国土特产', row)
    // 铺货到中国土特产
    syncToTTCRef.value.show(row);
  }
}
async function deleteSumit(row) {
  const res = await app.$axios.post(app.$api.supplychain.unRelation, {
    id: row.id,
    relationSupplierId: row.relationSupplierId,
  });
  if (res.code === 0) {
    app.$message.success('操作成功！');
    getList();
  }
}
async function deleteProduct(row) {
  const res = await app.$axios.post(app.$api.supplychain.deleteProduct, {
    id: row.id,
  });

  if (res.code === 0) {
    app.$message.success('操作成功！');
    getList();
  }
}
// 分页控制
function handleSizeChange(val) {
  params.nowPageSize = val;
  params.currentPage = 1;
  getList();
}
function handleCurrentChange(val) {
  params.currentPage = val;
  getList();
}
function getParams(page, type) {
  return {
    ...params,
    // lowEstimatedProfit: params.lowEstimatedProfit && (params.lowEstimatedProfit / 100).toFixed(3),
    // highEstimatedProfit: params.highEstimatedProfit && (params.highEstimatedProfit / 100).toFixed(3),
    // relationGoodsIds: params.relationGoodsIds
    //   ? (type === 'post' ? [params.relationGoodsIds] : params.relationGoodsIds)
    //   : [],
    goodsId: params.goodsId,
    currentPage: page || params.currentPage,
    pageSize: params.nowPageSize,
    nowPageSize: undefined,
    count: undefined,
  };
}
async function getList(num) {
  loading.value = true;
  const res = await app.$axios.post(app.$api.supplychain.relateGoodsList, getParams(num, 'post'));
  loading.value = false;
  if (res.code === 0) {
    const list = res.data.records || [];
    params.count = Number(res.data.total);

    list.forEach(row => {
      row.lastTimeStr = row.lastRelationTime ? dayjs(row.lastRelationTime).format('YYYY-MM-DD hh:mm:ss') : '--';
      row.updateToErpLoading = false;
    });

    tableData.value = list;
  }
}
function changeTag(item) {
  params.relationGoodsTagIds = item;
  getList(1);
}
function changeSupplier(e) {
  params.relationSupplierName = e.suppliersName;
  getList(1);
}
function setFixed(params, key, num = 0) {
  params[key] = parseFloat(params[key]) ? parseFloat(params[key]).toFixed(num) : '';
}
onMounted(() => {
  getList(1);
});

function changePage(tab) {
  if (tab.name === 'no') app.$router.push('/supplyChain/goods/index');
}

function addBtn() {
  AddGoodsRef.value.show();
}

function syncBtn() {
  showSyncDialog.value = true;
}

function closeSyncDialog() {
  showSyncDialog.value = false;
  // 重置表单
  syncGoodsId.value = '';
  syncRelationSupplierId.value = '';
  syncQudaoType.value = [1];
  syncYxIsOnSale.value = 1;
}

async function submitSync() {
  try {
    // 手动验证表单
    if (!syncGoodsId.value) {
      app.$message.error('请输入商品ID');
      return;
    }

    // 验证商品ID长度
    if (syncGoodsId.value.toString().length > 19) {
      app.$message.error('商品ID长度不能超过19位');
      return;
    }

    // 验证关联供应商长度
    if (syncRelationSupplierId.value && syncRelationSupplierId.value.toString().length > 19) {
      app.$message.error('关联供应商ID长度不能超过19位');
      return;
    }

    // 校验商品是否可以同步
    const res = await app.$axios.post(app.$api.supplychain.checkBeforeSelfAdd, {
      goodsId: syncGoodsId.value,
      relationSupplierId: syncRelationSupplierId.value,
    });
    if (res.code !== 0) return;

    syncLoading.value = true;
    const params = {id: syncGoodsId.value, type: 1};
    const result = await app.$axios.get(app.$api.goodsmanage.trade_goods_detail, {params});
    if (result.code !== 0) return;

    const {tradeGoodsDto} = result.data || {};

    if (!tradeGoodsDto || tradeGoodsDto.ancestryCategoryId !== '1') {
      app.$message({type: 'error', message: '仅支持农副产品商品复制后新增'});
      return;
    }

    const query = {
      storeId: userInfo.defaultStoreId,
      suppliersId: userInfo.suppliersId,
      goodsBuyType: '0',
      from: 'addgyl',
      yxIsOnSale: syncYxIsOnSale.value,
      scIsOnSale: syncQudaoType.value.includes(2) ? 1 : 0,
      syncErp: syncQudaoType.value.includes(3) ? 1 : 0 ,
      relationSupplierId: syncRelationSupplierId.value,
      relationSupplierName: tradeGoodsDto.relationSupplierName,
      activeSteps: 1,
      goodsType: 1,
      type: 'edit',
      goodsId: syncGoodsId.value,
      backendCategoryId: tradeGoodsDto.backendCategoryId,
      isSync: 1,// 是否为同步商品操作
    };
    syncQudaoType.value.includes(4) && (query.ttcIsOnSale = syncTTCIsOnSale.value);

    const route = app.$router.resolve({path: '/nb/goods/add', query});
    window.open(window.location.origin + route.href);

    if (syncRes.code === 0) {
      app.$message.success('同步商品成功！');
      closeSyncDialog();
      getList(1); // 刷新列表
    } else {
      app.$message.error(syncRes.msg || '同步商品失败');
    }
  } catch (error) {
    console.error('同步商品失败:', error);
    app.$message.error('同步商品失败，请重试');
  } finally {
    syncLoading.value = false;
  }
}

function updateToErp(row) {
  row.updateToErpLoading = true;
  sleep(updateToErpFn, {args: [row]});
}
async function updateToErpFn(row) {
  const params = {id: row.id};
  const result = await app.$axios.get(app.$api.goodsmanage.yxGoodsSyncErp, {params});
  row.updateToErpLoading = false;
  if (result.code !== 0) return;
  app.$message({type: 'success', message: '操作成功'});
}

function syncToTTCSuccess() {
  handleCurrentChange(1);
}

</script>

<template>
  <div class="outer supply-chain">
    <el-tabs v-model="pageTab" @tab-click="changePage" style="margin-bottom: 30px;">
      <el-tab-pane label="选品池" name="no"></el-tab-pane>
      <el-tab-pane label="供应链池" name="yes"></el-tab-pane>
    </el-tabs>
    <search-panel
      show-btn
      flex
      @getList="getList(1)"
    >
      <template v-if="isReset">
        <div>
          <p>商品类目</p>
          <ChangeCat
            :parent-id="1"
            @change="handleChange"
          />
        </div>
        <div>
          <p>供应商</p>
          <!-- <SearchSelectSupplier @change="changeSupplier" /> -->
          <el-input
            v-model="params.relationSupplierName"
            clearable
            placeholder="请输入内容"
            size="mini"
            @clear="getList(1)"
          />
        </div>
        <div>
          <p>商品名称</p>
          <el-input
            v-model="params.goodsName"
            clearable
            placeholder="请输入内容"
            size="mini"
            @clear="getList(1)"
          />
        </div>
        <div>
          <p style="width: 100%;">优选商品ID</p>
          <el-input
            v-model="params.goodsId"
            size="mini"
            placeholder="请输入内容"
            clearable
            maxlength="19"
            @blur="setFixed(params, 'goodsId')"
          />
        </div>
        <div>
          <p>供应商状态</p>
          <el-select
            v-model="params.isRelation"
            placeholder="请选择"
            size="mini"
            clearable
            @change="getList(1)"
          >
            <el-option label="关联供应商" :value="1" />
            <el-option label="未关联供应商" :value="0" />
          </el-select>
        </div>
        <div>
          <p>选品中心状态</p>
          <el-select
            v-model="params.scState"
            placeholder="请选择"
            size="mini"
            clearable
            @change="getList(1)"
          >
            <el-option label="上架" :value="1" />
            <el-option label="下架" :value="0" />
          </el-select>
        </div>
      </template>

      <el-button
        slot="button-right"
        size="mini"
        @click="operation('reset')"
      >
        重 置
      </el-button>
      <el-button
        slot="button-right"
        size="mini"
        type="primary"
        @click="addBtn"
      >
        新增商品
      </el-button>
      <!-- <el-button
        slot="button-right"
        size="mini"
        type="success"
        @click="syncBtn"
      >
        同步商品
      </el-button> -->
      <!-- <el-button
        slot="button-right"
        size="mini"
        @click="operation('export')"
      >
        导 出
      </el-button> -->
    </search-panel>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      class="tableBox"
      element-loading-text="拼命加载中"
      style="width: 100%"
      row-key="id"
      :header-cell-style="{
        background: '#f5f7fa',
      }"
      size="medium"
    >
      <el-table-column type="expand">
        <template slot-scope="{row}">
          <el-table
            :data="row.tradeGoodsSkuDtoList || []"
            style="margin-left: 148px"
            size="medium"
          >
            <el-table-column
              label="商品规格"
              width="300"
            >
              <template slot-scope="scope">
                <div class="wd-flex wd-flex-align-center">
                  <el-image
                    style="width: 50px; height: 50px"
                    :src="scope.row.imageIds"
                    :preview-src-list="[scope.row.imageIds]"
                    fit="cover"
                  />
                  <div class="margin-l5">
                    {{ scope.row.specValue }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="id"
              label="规格ID"
            />
            <el-table-column
              label="店铺销售价（元）"
              width="180"
            >
              <template slot-scope="scope">
                {{ +scope.row.sellPrice }}
              </template>
            </el-table-column>
            <el-table-column
              label="订货价（元）"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <div>{{scope.row.supplyPrice || 0}}</div>
                <div v-if="scope.row.supplyType === 1">(直接设置)</div>
                <div v-else-if="scope.row.supplyType === 2">(以佣金比例{{Number((scope.row.supplyPercent*100).toFixed(0))}}%设置)</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="estimatedProfit"
              label="预估毛利（%)"
            >
              <template slot-scope="scope">
                {{ +(scope.row.estimatedProfit * 100).toFixed(2) }}
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsId"
        label="优选商品ID"
        width="100"
      />
      <el-table-column
        prop="goodsName"
        label="商品名称"
        min-width="100"
      />
      <el-table-column
        prop="backendCategoryPath"
        label="商品类目"
        min-width="150"
      />
      <el-table-column
        prop="tagName"
        label="商品标签"
      />
      <el-table-column
        prop="salesSumTrue"
        label="店铺销量"
      />
      <el-table-column
        label="预估毛利（%）"
      >
        <template slot-scope="{row}">
          <span v-if="row.lowEstimatedProfit === row.highEstimatedProfit">
            {{ +(row.lowEstimatedProfit * 100).toFixed(2) }}
          </span>
          <span v-else>
            {{ +(row.lowEstimatedProfit * 100).toFixed(2) }}
            ~
            {{ +(row.highEstimatedProfit * 100).toFixed(2) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="订货价（元）"
      >
        <template slot-scope="{row}">
          <span v-if="row.lowSupplyPrice === row.highSupplyPrice">
            {{ +row.lowSupplyPrice }}
          </span>
          <span v-else>
            {{ +row.lowSupplyPrice }} ~ {{ +row.highSupplyPrice }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="店铺销售价（元）"
      >
        <template slot-scope="{row}">
          <span v-if="row.lowSellPrice === row.highSellPrice">
            {{ +row.lowSellPrice }}
          </span>
          <span v-else>
            {{ +row.lowSellPrice }} ~ {{ +row.highSellPrice }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="供应商"
      >
        <template slot-scope="{row}">
          {{ row.relationSupplierName }}
          <el-tooltip
            v-if="row.relationSupplierStatusStr"
            class="item"
            effect="dark"
            :content="row.relationSupplierStatusStr"
            placement="top"
          >
            <i
              class="el-icon-warning red"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="选品中心状态">
        <template slot-scope="{row}">
          {{row.scState === 1 ? '上架' : '下架'}}
        </template>
      </el-table-column>
      <el-table-column label="退货地址" width="180">
        <template slot-scope="{row}">
          <div>收货人：{{row.refundReceiveName}}</div>
          <div>收货手机号：{{row.refundReceiveMobile}}</div>
          <div>收货地址：{{row.refundAddress}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
      >
        <template
          slot-scope="{row}"
        >
          <el-link
            v-if="row.isRelation === 1"
            type="danger"
            :underline="false"
            @click="operation('delete', row)"
          >
            解除关联
          </el-link>
          <el-button type="text" :loading="row.updateToErpLoading"  @click="updateToErp(row)">铺货/更新到ERP</el-button>
          <el-link
          v-if="row.ttcIsOnSale === null"
            type="primary"
            :underline="false"
            @click="operation('syncToTTC', row)"
          >
            铺货到中国土特产
          </el-link>
          <br/>
          <el-link
            type="primary"
            :underline="false"
            @click="operation('setGoodsOnOff', row)"
          >
            设置商品上下架
          </el-link>
          <br/>
          <!-- <el-link
            type="danger"
            :underline="false"
            @click="operation('deleteProduct', row)"
          >
            删除
          </el-link> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="tableData && tableData.length > 0"
      :current-page="params.currentPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="params.nowPageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="params.count"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />

    <AddGoods ref="AddGoodsRef" />
    <setGoodsOnOff ref="setGoodsOnOffRes" />
    <SyncToTTC ref="syncToTTCRef" @syncToTTCSuccess="syncToTTCSuccess" />
    <!-- 同步商品弹窗 -->
    <el-dialog
      :visible.sync="showSyncDialog"
      title="同步商品"
      width="700px"
      :before-close="closeSyncDialog"
    >
      <div class="sync-dialog-content">
        <div class="sync-subtitle">
          将下方ID商品同步到优选店铺&供应链&选品中心/ERP，并关联供应商。（仅支持优选店铺商品/优选推荐商品/选品中心商品同步）
        </div>

        <el-form ref="syncForm" label-width="120px">
          <el-form-item label="商品ID">
            <el-input
              v-model="syncGoodsId"
              placeholder="请输入商品ID"
              clearable
              maxlength="19"
            />
          </el-form-item>

          <el-form-item label="关联供应商">
            <el-input
              v-model="syncRelationSupplierId"
              placeholder="请输入供应商ID"
              clearable
              maxlength="19"
            />
            <div class="tip-text">
              若需要关联选品中心的源头商家，请在上方输入源头商家ID。
            </div>
          </el-form-item>

          <el-form-item label="铺品渠道">
            <el-checkbox-group v-model="syncQudaoType">
              <el-checkbox disabled :label="1">农博优选 <span style="color: gray">（已属于优选店铺商品不同步仅修改上下架状态。）</span></el-checkbox>
              <el-radio-group v-model="syncYxIsOnSale">
                <el-radio :label="1">上架<span style="color: red">（若商品未关联供应商，订单由农博优选店发货，请谨慎操作）</span></el-radio>
                <el-radio :label="0">下架</el-radio>
              </el-radio-group>
              <el-checkbox :label="2">渠道选品中心<span style="color: gray">（已属于选品中心商品不同步仅修改为上架状态。）</span></el-checkbox>
              <el-checkbox :label="3">ERP<span style="color: red">（若商品未关联供应商，订单由农博优选店发货，请谨慎操作）</span></el-checkbox>
              <el-checkbox :label="4">中国土特产 <span style="color: gray">（已属于优选店铺商品不同步仅修改上下架状态。）</span></el-checkbox>
              <el-radio-group :disabled="!syncQudaoType.includes(4)" v-model="syncTTCIsOnSale">
                <el-radio :label="1">上架<span style="color: red">（若商品未关联供应商，订单由农博优选店发货，请谨慎操作）</span></el-radio>
                <el-radio :label="0">下架</el-radio>
              </el-radio-group>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeSyncDialog">取 消</el-button>
        <el-button type="primary" @click="submitSync" :loading="syncLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.tableBox{
  :deep(.el-table__header){
    .el-table__cell{
      font-weight: bold;
      color: #333;
    }
  }
  :deep(.el-table__row){
    font-size: 12px;
  }
}
:deep(.el-input-number .el-input__inner) {
  text-align: left;
}
.input_box :deep(input) {
  border-color: red;
}

// 同步商品弹窗样式
.sync-dialog-content {
  .sync-subtitle {
    color: #666;
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border-left: 4px solid #409eff;
  }

  .tip-text {
    color: #909399;
    font-size: 12px;
    margin-top: 5px;
    line-height: 1.4;
  }

  .el-checkbox-group {
    .el-checkbox {
      margin-bottom: 10px;
      display: block;
    }

    .el-radio-group {
      margin-left: 20px;
      margin-top: 5px;

      .el-radio {
        margin-bottom: 5px;
        display: block;
      }
    }
  }
}
</style>
